// import React from "react";
// // import {
// //   FaPinterestP,
// //   FaXTwitter,
// //   FaFacebookF,
// //   FaInstagram,
// // } from "react-icons/fa6";
// import { Link } from "react-router-dom";

// const Footer = () => {
//   const handleOnsubmit = (e) => {
//     e.preventDefault();
//     const email = e.target[0].value; // first input in the form
//     console.log("Newsletter email:", email);
//   };

//   return (
//     <footer className="bg-black text-white pt-16 pb-6 relative z-10">
//       <div className="max-w-7xl mx-auto px-[10px] md:px-0">
//         {/* Header CTA */}
//         <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left gap-6 mb-10">
//           {/* <h2 className="text-4xl md:text-5xl font-bold leading-tight">
//             We conduct group golf lessons &<br className="hidden md:block" />
//             tournaments, training
//           </h2> */}
//           {/* <h2 className="text-4xl md:text-5xl font-bold leading-tight">
//             We conduct frequent golf tournaments
//           </h2> */}
//           {/* <Link
//             to="/membership"
//             className="relative group overflow-hidden bg-lime-400 text-black font-bold py-3 px-6 rounded-full flex items-center space-x-2 transition-colors duration-500"
//           >

//             <span className="absolute inset-0 bg-black origin-bottom-left scale-x-0 group-hover:scale-x-100 transition-transform duration-700 ease-in-out z-0"></span>

//             <span className="relative z-10 flex items-center space-x-2 group-hover:text-white transition-colors duration-500">
//               <span className="uppercase">Get Membership</span>
//               <svg
//                 className="w-5 h-5"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth={2}
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   d="M9 5l7 7-7 7"
//                 />
//               </svg>
//             </span>
//           </Link> */}
//         </div>

//         {/* <hr className="border-gray-700 mb-10" /> */}

//         {/* Footer Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
//           {/* Logo & Social */}
//           <div>
//             <div className="flex items-center gap-2 mb-4">
//               <div className="bg-yellow-300 rounded-full w-10 h-10 flex items-center justify-center font-black text-lg text-black">
//                 ✔
//               </div>
//               <h3 className="text-xl font-bold">RGCC.</h3>
//             </div>
//             <p className="text-sm text-gray-400">
//               Experience World-Class Golf Facilities and Tournaments at
//               Prestigious Rangpur Golf & Country Club.
//             </p>
//             {/* <div className="flex gap-4 mt-4 text-lime-400 text-xl">
//               <FaPinterestP />
//               <FaXTwitter />
//               <FaFacebookF />
//               <FaInstagram />
//             </div> */}
//           </div>

//           {/* Contact Info */}
//           <div>
//             <h4 className="text-lg font-semibold mb-4">Say Hello</h4>
//             <ul className="text-sm text-gray-400 space-y-2">
//               <li>+88 01766693142</li>
//               <li>rgcc66div@gmail.com</li>
//               <li>Ghaghat, Rangpur (Near Ghaghat Bridge)</li>
//             </ul>
//           </div>

//           {/* Quick Links */}
//           <div>
//             <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
//             <ul className="text-sm text-gray-400 space-y-2">
//               <li className="hover:text-lime-400 cursor-pointer">
//                 <Link to="/">Home</Link>
//               </li>
//               <li className="hover:text-lime-400 cursor-pointer">
//                 <Link to="/about">About Us</Link>
//               </li>
//               {/* <li className="hover:text-lime-400 cursor-pointer">
//                 <Link to="/">Courses</Link>
//               </li>
//               <li className="hover:text-lime-400 cursor-pointer">
//                 <Link to="/">Blogs</Link>
//               </li> */}
//             </ul>
//           </div>

//           {/* Newsletter */}
//           <div>
//             <h4 className="text-lg font-semibold mb-4">Newsletters</h4>
//             <form className="flex flex-col gap-4" onSubmit={handleOnsubmit}>
//               <input
//                 type="email"
//                 placeholder="Enter your email"
//                 className="px-4 py-2 rounded-md bg-gray-900 text-white placeholder:text-gray-500 focus:outline-none"
//               />
//               <button
//                 type="submit"
//                 className="bg-lime-400 text-black font-semibold uppercase rounded-full px-6 py-2 hover:bg-white transition duration-300"
//               >
//                 Subscribe Now
//               </button>
//             </form>
//           </div>
//         </div>

//         {/* Footer bottom */}
//         <div className="mt-10 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500 gap-4">
//           <p>Copyright © 2025 All Rights Reserved.</p>
//           <div className="flex gap-4">
//             <Link href="#" className="hover:text-white">
//               Help
//             </Link>
//             <Link href="#" className="hover:text-white">
//               Privacy Policy
//             </Link>
//             <Link href="#" className="hover:text-white">
//               Term’s & Condition
//             </Link>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

// import React from "react";
// import { Link } from "react-router-dom";
// import {
//   FaFacebookF,
//   FaTwitter,
//   FaInstagram,
//   FaLinkedinIn,
//   FaMapMarkerAlt,
//   FaPhoneAlt,
//   FaEnvelope,
// } from "react-icons/fa";

// const Footer = () => {
//   const handleOnsubmit = (e) => {
//     e.preventDefault();
//     const email = e.target[0].value;
//     console.log("Newsletter email:", email);
//     e.target.reset();
//   };

//   const quickLinks = [
//     { label: "Home", path: "/" },
//     { label: "About Us", path: "/about" },
//     { label: "Services", path: "/services" },
//     { label: "Membership", path: "/membership" },
//     { label: "Golf Course", path: "/golf-course" },
//     { label: "Events", path: "/upcoming-events" },
//     { label: "Facilities", path: "/facilites-guests" },
//     { label: "Contact", path: "/contact" },
//   ];

//   const aboutLinks = [
//     { label: "Our Mission", path: "/mission" },
//     { label: "Our Vision", path: "/vision" },
//     { label: "Leadership Team", path: "/leadership-team" },
//     { label: "Our History", path: "/about" },
//     { label: "Sponsors", path: "/sponsors" },
//     { label: "Gallery", path: "/image-gallery" },
//   ];

//   const supportLinks = [
//     { label: "Help Center", path: "/help" },
//     { label: "Privacy Policy", path: "/privacy" },
//     { label: "Terms & Conditions", path: "/terms" },
//     { label: "FAQs", path: "/faqs" },
//     { label: "Site Map", path: "/sitemap" },
//   ];

//   const socialLinks = [
//     {
//       icon: FaFacebookF,
//       url: "https://www.facebook.com/rgcc66infdiv",
//       color: "hover:text-blue-500",
//     },
//     { icon: FaTwitter, url: "#", color: "hover:text-blue-400" },
//     { icon: FaInstagram, url: "#", color: "hover:text-pink-500" },
//     { icon: FaLinkedinIn, url: "#", color: "hover:text-blue-600" },
//   ];

//   return (
//     <footer className="bg-gradient-to-b from-gray-900 to-black text-white pt-16 pb-8 relative z-10 border-t border-gray-800">
//       <div className="max-w-7xl mx-auto px-6 lg:px-8">
//         {/* Footer Grid */}
//         <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-7 gap-8 mb-12">
//           {/* Brand Section */}
//           <div className="xl:col-span-2">
//             <div className="flex items-center gap-3 mb-6">
//               <div className="bg-emerald-500 rounded-full w-12 h-12 flex items-center justify-center font-black text-lg text-white shadow-lg">
//                 ✓
//               </div>
//               <h3 className="text-2xl font-bold bg-gradient-to-r from-emerald-400 to-green-300 bg-clip-text text-transparent">
//                 RGCC
//               </h3>
//             </div>
//             <p className="text-gray-300 leading-relaxed mb-6 max-w-md">
//               Experience World-Class Golf Facilities and Tournaments at
//               Prestigious Rangpur Golf & Country Club. Where excellence meets
//               tradition in every swing.
//             </p>

//             {/* Social Links */}
//             <div className="flex gap-4">
//               {socialLinks.map((SocialIcon, index) => (
//                 <a
//                   key={index}
//                   href={SocialIcon.url}
//                   className={`w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center transition-all duration-300 ${SocialIcon.color} hover:bg-gray-700 hover:scale-110 border border-gray-700`}
//                 >
//                   <SocialIcon.icon className="w-4 h-4" />
//                 </a>
//               ))}
//             </div>
//           </div>

//           {/* Quick Links */}
//           <div>
//             <h4 className="text-lg font-semibold mb-6 text-white relative inline-block border-b-2 border-emerald-500">
//               Quick Links
//               {/* <span className="absolute bottom-0 left-0 w-1/2 h-0.5 bg-emerald-500"></span> */}
//             </h4>
//             <ul className="space-y-3">
//               {quickLinks.map((link, index) => (
//                 <li key={index}>
//                   <Link
//                     to={link.path}
//                     className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 flex items-center group text-sm"
//                   >
//                     <span className="w-2 h-2 bg-emerald-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
//                     {link.label}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* About Links */}
//           <div>
//             <h4 className="text-lg font-semibold mb-6 text-white relative inline-block border-b-2 border-emerald-500">
//               About RGCC
//               {/* <span className="absolute bottom-0 left-0 w-1/2 h-0.5 bg-emerald-500"></span> */}
//             </h4>
//             <ul className="space-y-3">
//               {aboutLinks.map((link, index) => (
//                 <li key={index}>
//                   <Link
//                     to={link.path}
//                     className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 flex items-center group text-sm"
//                   >
//                     <span className="w-2 h-2 bg-emerald-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
//                     {link.label}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Support Links */}
//           <div>
//             <h4 className="text-lg font-semibold mb-6 text-white relative inline-block border-b-2 border-emerald-500">
//               Support
//               {/* <span className="absolute bottom-0 left-0 w-1/2 h-0.5 bg-emerald-500"></span> */}
//             </h4>
//             <ul className="space-y-3">
//               {supportLinks.map((link, index) => (
//                 <li key={index}>
//                   <Link
//                     to={link.path}
//                     className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 flex items-center group text-sm"
//                   >
//                     <span className="w-2 h-2 bg-emerald-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
//                     {link.label}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Contact & Newsletter */}
//           <div className="xl:col-span-2 lg:col-span-2">
//             <h4 className="text-lg font-semibold mb-6 text-white relative inline-block border-b-2 border-emerald-500">
//               Stay Updated
//               {/* <span className="absolute bottom-0 left-0 w-1/2 h-0.5 bg-emerald-500"></span> */}
//             </h4>

//             {/* Contact Info */}
//             <div className="mb-6 space-y-4">
//               <div className="flex items-center gap-3 text-gray-300 group">
//                 <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-600 transition-colors duration-200">
//                   <FaMapMarkerAlt className="w-3 h-3 text-white" />
//                 </div>
//                 <span className="text-sm">
//                   Ghaghat, Rangpur (Near Ghaghat Bridge)
//                 </span>
//               </div>

//               <div className="flex items-center gap-3 text-gray-300 group">
//                 <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-600 transition-colors duration-200">
//                   <FaPhoneAlt className="w-3 h-3 text-white" />
//                 </div>
//                 <span className="text-sm">+88 01766693142</span>
//               </div>

//               <div className="flex items-center gap-3 text-gray-300 group">
//                 <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-600 transition-colors duration-200">
//                   <FaEnvelope className="w-3 h-3 text-white" />
//                 </div>
//                 <span className="text-sm">rgcc66div@gmail.com</span>
//               </div>
//             </div>

//             {/* Newsletter */}
//             <form className="space-y-4" onSubmit={handleOnsubmit}>
//               <div className="relative">
//                 <input
//                   type="email"
//                   placeholder="Enter your email"
//                   className="w-full px-4 py-3 rounded-lg bg-gray-800 border border-gray-700 text-white placeholder-gray-400 focus:outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 transition-all duration-200"
//                   required
//                 />
//               </div>
//               <button
//                 type="submit"
//                 className="w-full bg-gradient-to-r from-emerald-500 to-green-600 text-white font-semibold py-3 px-6 rounded-lg hover:from-emerald-600 hover:to-green-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-emerald-500/25"
//               >
//                 Subscribe Now
//               </button>
//             </form>
//           </div>
//         </div>

//         {/* Footer Bottom */}
//         <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
//           <p className="text-gray-400 text-sm">
//             © {new Date().getFullYear()} Rangpur Golf & Country Club. All rights
//             reserved.
//           </p>

//           <div className="flex gap-6 text-sm">
//             <Link
//               to="/privacy"
//               className="text-gray-400 hover:text-emerald-400 transition-colors duration-200"
//             >
//               Privacy Policy
//             </Link>
//             <Link
//               to="/terms"
//               className="text-gray-400 hover:text-emerald-400 transition-colors duration-200"
//             >
//               Terms & Conditions
//             </Link>
//             <Link
//               to="/help"
//               className="text-gray-400 hover:text-emerald-400 transition-colors duration-200"
//             >
//               Help
//             </Link>
//           </div>
//         </div>

//         {/* Decorative Elements */}
//         <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-emerald-500 via-green-500 to-emerald-500 opacity-20"></div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";

const Footer = () => {
  const handleOnsubmit = (e) => {
    e.preventDefault();
    const email = e.target[0].value;
    console.log("Newsletter email:", email);
    e.target.reset();
  };

  const quickLinks = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Services", path: "/services" },
    { label: "Membership", path: "/membership" },
    { label: "Golf Course", path: "/golf-course" },
    { label: "Events", path: "/upcoming-events" },
    { label: "Facilities", path: "/facilites-guests" },
    { label: "Contact", path: "/contact" },
  ];

  const aboutLinks = [
    { label: "Our Mission", path: "/mission" },
    { label: "Our Vision", path: "/vision" },
    { label: "Leadership Team", path: "/leadership-team" },
    { label: "Our History", path: "/about" },
    { label: "Sponsors", path: "/sponsors" },
    { label: "Gallery", path: "/image-gallery" },
  ];

  const supportLinks = [
    { label: "Help Center", path: "/help" },
    { label: "Privacy Policy", path: "/privacy" },
    { label: "Terms & Conditions", path: "/terms" },
    { label: "FAQs", path: "/faqs" },
    { label: "Site Map", path: "/sitemap" },
  ];

  const socialLinks = [
    {
      icon: FaFacebookF,
      url: "https://www.facebook.com/rgcc66infdiv",
      color: "hover:text-blue-500",
    },
    { icon: FaTwitter, url: "#", color: "hover:text-blue-400" },
    { icon: FaInstagram, url: "#", color: "hover:text-pink-500" },
    { icon: FaLinkedinIn, url: "#", color: "hover:text-blue-600" },
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white pt-12 sm:pt-16 pb-6 sm:pb-8 relative z-10 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Footer Grid */}
        <div className="grid grid-cols-2 xs:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {/* Brand Section */}
          <div className="xs:col-span-2 lg:col-span-2 xl:col-span-2">
            <div className="flex items-center gap-3 mb-4 sm:mb-6">
              <div className="bg-emerald-500 rounded-full w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center font-black text-base sm:text-lg text-white shadow-lg">
                ✓
              </div>
              <h3 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-emerald-400 to-green-300 bg-clip-text text-transparent">
                RGCC
              </h3>
            </div>
            <p className="text-gray-300 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base max-w-md">
              Experience World-Class Golf Facilities and Tournaments at
              Prestigious Rangpur Golf & Country Club. Where excellence meets
              tradition in every swing.
            </p>

            {/* Social Links */}
            <div className="flex gap-3 sm:gap-4">
              {socialLinks.map((SocialIcon, index) => (
                <a
                  key={index}
                  href={SocialIcon.url}
                  className={`w-8 h-8 sm:w-10 sm:h-10 bg-gray-800 rounded-lg flex items-center justify-center transition-all duration-300 ${SocialIcon.color} hover:bg-gray-700 hover:scale-110 border border-gray-700`}
                >
                  <SocialIcon.icon className="w-3 h-3 sm:w-4 sm:h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="mt-4 sm:mt-0">
            <h4 className="text-base sm:text-lg font-semibold mb-4 sm:mb-6 text-white border-b-2 border-emerald-500 pb-2 inline-block">
              Quick Links
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              {quickLinks.slice(0, 4).map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 flex items-center group text-xs sm:text-sm"
                  >
                    <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-emerald-500 rounded-full mr-2 sm:mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About Links */}
          <div className="mt-4 sm:mt-0">
            <h4 className="text-base sm:text-lg font-semibold mb-4 sm:mb-6 text-white border-b-2 border-emerald-500 pb-2 inline-block">
              About RGCC
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              {aboutLinks.slice(0, 4).map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 flex items-center group text-xs sm:text-sm"
                  >
                    <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-emerald-500 rounded-full mr-2 sm:mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div className="xs:col-span-2 lg:col-span-2 xl:col-span-2 mt-4 sm:mt-0">
            <h4 className="text-base sm:text-lg font-semibold mb-4 sm:mb-6 text-white border-b-2 border-emerald-500 pb-2 inline-block">
              Contact & Newsletter
            </h4>

            {/* Contact Info */}
            <div className="mb-4 sm:mb-6 space-y-3 sm:space-y-4">
              <div className="flex items-start gap-2 sm:gap-3 text-gray-300 group">
                <div className="w-6 h-6 sm:w-8 sm:h-8 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-600 transition-colors duration-200 mt-0.5">
                  <FaMapMarkerAlt className="w-2 h-2 sm:w-3 sm:h-3 text-white" />
                </div>
                <span className="text-xs sm:text-sm flex-1">
                  Ghaghat, Rangpur (Near Ghaghat Bridge)
                </span>
              </div>

              <div className="flex items-center gap-2 sm:gap-3 text-gray-300 group">
                <div className="w-6 h-6 sm:w-8 sm:h-8 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-600 transition-colors duration-200">
                  <FaPhoneAlt className="w-2 h-2 sm:w-3 sm:h-3 text-white" />
                </div>
                <span className="text-xs sm:text-sm">+88 01766693142</span>
              </div>

              <div className="flex items-center gap-2 sm:gap-3 text-gray-300 group">
                <div className="w-6 h-6 sm:w-8 sm:h-8 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-600 transition-colors duration-200">
                  <FaEnvelope className="w-2 h-2 sm:w-3 sm:h-3 text-white" />
                </div>
                <span className="text-xs sm:text-sm">rgcc66div@gmail.com</span>
              </div>
            </div>

            {/* Newsletter */}
            <form className="space-y-3 sm:space-y-4" onSubmit={handleOnsubmit}>
              <div className="relative">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 rounded-lg bg-gray-800 border border-gray-700 text-white placeholder-gray-400 focus:outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 transition-all duration-200 text-sm"
                  required
                />
              </div>
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-emerald-500 to-green-600 text-white font-semibold py-2 sm:py-3 px-4 sm:px-6 rounded-lg hover:from-emerald-600 hover:to-green-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-emerald-500/25 text-sm sm:text-base"
              >
                Subscribe Now
              </button>
            </form>
          </div>
        </div>

        {/* Additional Links for Mobile */}
        <div className="lg:hidden grid grid-cols-2 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Quick Links - Remaining */}
          <div>
            <h4 className="text-base font-semibold mb-4 text-white border-b-2 border-emerald-500 pb-2 inline-block">
              More Links
            </h4>
            <ul className="space-y-2">
              {quickLinks.slice(4).map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 flex items-center group text-xs"
                  >
                    <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About Links - Remaining */}
          <div>
            <h4 className="text-base font-semibold mb-4 text-white border-b-2 border-emerald-500 pb-2 inline-block">
              More About
            </h4>
            <ul className="space-y-2">
              {aboutLinks.slice(4).map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 flex items-center group text-xs"
                  >
                    <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Support Links for Mobile */}
        <div className="lg:hidden mb-6">
          <h4 className="text-base font-semibold mb-4 text-white border-b-2 border-emerald-500 pb-2 inline-block">
            Support
          </h4>
          <div className="grid grid-cols-2 gap-4">
            {supportLinks.map((link, index) => (
              <Link
                key={index}
                to={link.path}
                className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 text-xs"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="pt-6 sm:pt-8 border-t border-gray-800 flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
          <p className="text-gray-400 text-xs sm:text-sm text-center sm:text-left">
            © {new Date().getFullYear()} Rangpur Golf & Country Club. All rights
            reserved.
          </p>

          <div className="flex flex-wrap justify-center gap-3 sm:gap-4 sm:gap-6 text-xs sm:text-sm">
            <Link
              to="/privacy"
              className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 whitespace-nowrap"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 whitespace-nowrap"
            >
              Terms & Conditions
            </Link>
            <Link
              to="/help"
              className="text-gray-400 hover:text-emerald-400 transition-colors duration-200 whitespace-nowrap"
            >
              Help
            </Link>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-emerald-500 via-green-500 to-emerald-500 opacity-20"></div>
      </div>
    </footer>
  );
};

export default Footer;
